export const MINUTE_MS = 60 * 1000;
export const HOUR_MS = 60 * MINUTE_MS;
export const DAY_MS = 24 * HOUR_MS;
export const MONTH_MS = 30 * DAY_MS;

export const FAMILY_ACTIVITY_BOTTOM_CLEARANCE = 68;
